import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Inventories_Object} state
 *  @property {object} model
 *  @property {Inventories_Properties} model.properties
 *  @property {Inventories_Is} model.is
 *  @property {Inventories_Has} model.has
 */
export default class InventoryObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Inventories._name);
		this.ended = ' ';
	}

	/**
	 * @param prevProps
	 * @param {Inventories_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Inventories_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.title);
		}
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		if (typeof this.props.setNewObject === 'function') {
			this.props.setNewObject(data);
		}
	};

	handleComplete() {
		this.ended = 'Complete';
		this.handleSubmit().then();
	}

	handleReopen() {
		this.ended = 'Reopen';
		this.handleSubmit().then();
	}

	async handleSubmit(event, suppressToast = false) {
		if (this.ended === 'Complete') {
			this.state.end_date = new Date().toISOString();
		} else if (this.ended === 'Reopen') {
			this.state.end_date = null;
		}
		await super.handleSubmit(event, suppressToast);
	}

	form = () => {
		/** @type {Inventories_Properties} properties */
		let properties = this.model.properties;
		/** @type {Inventories_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">Inventory</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Title"}
									value={object.title}
									error={object.title_error}
									property={properties.title}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterSubscribedOnlyLocations}
							/>

							{/*If an id is passed then we show dates for start and end*/}
							{this.state.pkey ?
								<div className={'form-group'}>
									<div className="row">
										<div className="col-6">
											<div className="form-group">
												<Framework.Elements.DateTime
													label={'Start Date'}
													property={properties.start_date}
													value={object.start_date}
													error={object.start_date_error}
													update={this.handleTextFieldPropertyUpdate}
													disabled={true}
												/>
											</div>
										</div>
										<div className={'col-6'}>
											<div className="form-group">
												<Framework.Elements.DateTime
													label={'End Date'}
													property={properties.end_date}
													value={object.end_date}
													error={object.end_date_error}
													update={this.handleTextFieldPropertyUpdate}
													disabled={true}
												/>
											</div>
										</div>
									</div>
								</div> : null}

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Notes"}
									property={properties.notes}
									value={object.notes}
									error={object.notes_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>

						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

	// Overriding the default so we can have a complete and re-open button
	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions>
					{/*Don't display these on creation, only when inside of the inventory count*/}
					{this.state.pkey && !this.state.end_date &&
					<Button color="primary" style={{marginRight: 'auto'}} onClick={this.handleComplete.bind(this)}>Complete</Button>}
					{this.state.pkey && this.state.end_date &&
					<Button color="primary" style={{marginRight: 'auto'}} onClick={this.handleReopen.bind(this)}>Re-Open</Button>}
					<Button color="danger" onClick={this.handleDelete}>Delete</Button>
					<Button color="primary" onClick={this.handleSubmit}>Save</Button>
				</CardActions>
			</Card>
		)
	}
}
